export const GET_WALKS = "GET_WALKS";

export const GET_USER = 'GET_USER';
export const ADD_PRO = 'ADD_PRO';
export const REMOVE_PRO = 'REMOVE_PRO'
export const REMOVE_USER = 'REMOVE_USER';
export const GET_LOCATION = 'GET_LOCATION';
export const ALLOW_LOCATION = 'ALLOW_LOCATION';
export const SET_MYWALKS_URL = 'SET_MYWALKS_URL';
export const SET_VIEW = 'SET_VIEW';
export const SET_TEAM = 'SET_TEAM';
export const SET_LANGUAGE = 'SET_LANGUAGE'

export const GET_MAP_OPTIONS = 'GET_MAP_OPTIONS';
export const UPDATE_MAP_OPTIONS = 'UPDATE_MAP_OPTIONS';

export const GET_ERRORS = 'GET_ERRORS';

export const CREATE_WALK = 'CREATE_WALK';

export const GET_FRIENDS = 'GET_FRIENDS';

export const OPEN_CHAT = 'OPEN_CHAT';
export const CLOSE_CHAT = 'CLOSE_CHAT'
export const GET_MESSAGES = 'GET_MESSAGES'

export const OPEN_ALERT = 'OPEN_ALERT'

export const OPEN_NOTICE = 'OPEN_NOTICE'

export const OPEN_PROFILE = 'OPEN_PROFILE'
export const CLOSE_PROFILE = 'CLOSE_PROFILE'

export const OPEN_TALK = 'OPEN_TALK';
export const CLOSE_TALK = 'CLOSE_TALK';
export const GET_CURRENT_WALK = 'GET_CURRENT_WALK'

export const UPDATE_FILTER = 'UPDATE_FILTER'

export const SET_PAGE = 'SET_PAGE'

export const GET_TALKROOM = 'GET_TALKROOM'

export const GET_NOTES = 'GET_NOTES'
export const ADD_NOTE = 'ADD_NOTE'
export const EDIT_NOTE = 'EDIT_NOTE'
export const DELETE_NOTE = 'DELETE_NOTE'
export const EDITING_NOTE = 'EDITING_NOTE'

export const SET_CURRENT_WALK = 'SET_CURRENT_WALK'
export const OPEN_CURRENT_WALK = 'OPEN_CURRENT_WALK'
export const CLOSE_CURRENT_WALK = 'CLOSE_CURRENT_WALK'

export const NOTE_WAS_EDITED = 'NOTE_WAS_EDITED'
export const NOTE_WAS_CREATED = 'NOTE_WAS_CREATED'
export const NOTE_WAS_DELETED = 'NOTE_WAS_DELETED'

export const OPEN_PREVIEW = 'OPEN_PREVIEW'
export const CLOSE_PREVIEW = 'CLOSE_PREVIEW'

export const SET_FILTER ='SET_FILTER'
export const SET_FILTER_PERSON ='SET_FILTER_PERSON'
export const SET_FILTER_TEAM ='SET_FILTER_TEAM'

export const SET_FILTER_TEAMARR = 'SET_FILTER_TEAMARR'
export const CLEAR_TEAMARR = 'CLEAR_TEAMARR'

export const REMOVE_WALK = 'REMOVE_WALK'

export const WAS_REPORTED = 'WAS_REPORTED'

export const SET_PRO = "SET_PRO"
export const SET_STORE = "SET_STORE"

export const SET_UNREAD = "SET_UNREAD"